import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import actionTypes from 'constants/actionTypes';
import { useAddFolderModal } from '../context/AddFolderModalContext';

const AddFolderModalHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddFolderModal();

  const modalTitle =
    data.modalActionType === actionTypes.ADD
      ? t('CreateFolder')
      : t('EditFolder');

  return (
    <Modal.Header>
      <h5 className="modal-title">{modalTitle}</h5>
      <a className="close" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default AddFolderModalHeader;
